import { GCPOverviewComponentProps } from './components/GCPOverviewComponent/GCPOverviewComponent';

import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

export const gcpPlugin = createPlugin({
  id: 'gcpPlugin',
});

export const GCPOverviewComponent: (
  props: GCPOverviewComponentProps,
) => JSX.Element | null = gcpPlugin.provide(
  createComponentExtension({
    component: {
      lazy: () =>
        import(
          './components/GCPOverviewComponent'
        ).then(m => m.GCPOverviewComponent),
    },
  }),
);
